import { LOCALISE_FULFILMENT } from '../../actionTypes/localiseFulfilmentActionTypes'

const localiseFulfilment = payload => ({
  type: LOCALISE_FULFILMENT,
  payload
})

export default localiseFulfilment
